import styled from "styled-components";
export var ButtonBase = styled.button.withConfig({
    componentId: "sc-ece8a5c2-0"
})([
    "display:flex;padding:4px;align-items:center;justify-content:center;width:",
    ";height:",
    ";&:disabled{pointer-events:none;}"
], function(props) {
    return props.$size;
}, function(props) {
    return props.$size;
});
export var Symbol = styled.div.withConfig({
    componentId: "sc-ece8a5c2-1"
})([
    "display:flex;align-items:center;justify-content:center;"
]);
